// Ashir: magnify the product photo under the cursor on desktop.
// Clicking still opens Horizon's full-screen zoom dialog; touch devices keep pinch-zoom.
const finePointer = matchMedia('(hover: hover) and (pointer: fine)');
const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
const SLIDE = 'media-gallery slideshow-slide';

/** @param {Element | null} slide */
const zoomable = (slide) =>
  slide instanceof HTMLElement &&
  slide.getAttribute('aria-hidden') !== 'true' &&
  !!slide.querySelector('img.product-media__image') &&
  !slide.querySelector('deferred-media, product-model, video, iframe');

/** @param {HTMLElement} slide */
const reset = (slide) => slide.classList.remove('ashir-zoom');

document.addEventListener('pointermove', (event) => {
  if (event.pointerType !== 'mouse' || !finePointer.matches || reducedMotion.matches) return;
  const slide = event.target instanceof Element ? event.target.closest(SLIDE) : null;
  if (!(slide instanceof HTMLElement) || !zoomable(slide)) return;

  const box = slide.getBoundingClientRect();
  const x = ((event.clientX - box.left) / box.width) * 100;
  const y = ((event.clientY - box.top) / box.height) * 100;
  slide.style.setProperty('--ashir-zoom-x', `${Math.min(100, Math.max(0, x))}%`);
  slide.style.setProperty('--ashir-zoom-y', `${Math.min(100, Math.max(0, y))}%`);
  slide.classList.add('ashir-zoom');
});

document.addEventListener('pointerout', (event) => {
  const slide = event.target instanceof Element ? event.target.closest(SLIDE) : null;
  if (!(slide instanceof HTMLElement)) return;
  if (event.relatedTarget instanceof Node && slide.contains(event.relatedTarget)) return;
  reset(slide);
});

// Moving between slides (arrows, thumbnails, drag) must never leave a slide magnified
document.addEventListener(
  'scroll',
  (event) => {
    if (event.target instanceof Element && event.target.matches('media-gallery slideshow-slides')) {
      event.target.querySelectorAll('.ashir-zoom').forEach((slide) => reset(/** @type {HTMLElement} */ (slide)));
    }
  },
  true
);
